import { Storage } from "../storage/storage";
import { RuleId } from "./Rules";

// What the tutorial remembers on the device (docs/specs/tutorial, R2.6, R3.4, R4).
const COMPLETED_LESSONS_KEY = "tutorialCompletedLessons";
const BANNER_HIDDEN_KEY = "tutorialBannerHidden";
const HINTS_KEY = "botGameHints";
const GAME_PLAYED_KEY = "gamePlayed";

export function getCompletedLessons(storage: Storage): RuleId[] {
    try {
        const saved = JSON.parse(storage.getString(COMPLETED_LESSONS_KEY) ?? "[]");
        return Array.isArray(saved) ? saved : [];
    } catch {
        return [];
    }
}

export function completeLesson(storage: Storage, id: RuleId): void {
    const completed = getCompletedLessons(storage);
    if (!completed.includes(id)) storage.setString(COMPLETED_LESSONS_KEY, JSON.stringify([...completed, id]));
}

export function hideTutorialBanner(storage: Storage): void {
    storage.setString(BANNER_HIDDEN_KEY, "true");
}

export function markGamePlayed(storage: Storage): void {
    storage.setString(GAME_PLAYED_KEY, "true");
}

// For newcomers only: nobody played a game on this device, opened the tutorial or dismissed the banner (R4).
export function shouldShowTutorialBanner(storage: Storage): boolean {
    return storage.getString(BANNER_HIDDEN_KEY) !== "true" && storage.getString(GAME_PLAYED_KEY) !== "true"
        && getCompletedLessons(storage).length === 0;
}

// Hints in games against the bot; off until turned on.
export function getHintsEnabled(storage: Storage): boolean {
    return storage.getString(HINTS_KEY) === "true";
}

export function setHintsEnabled(storage: Storage, enabled: boolean): void {
    storage.setString(HINTS_KEY, String(enabled));
}
